import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextBoldFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M6.16 3.19h9q5.26 0 7.81 1.56a5.29 5.29 0 0 1 2.55 4.86 6.15 6.15 0 0 1-1.11 3.71 5 5 0 0 1-2.93 2v.17a6 6 0 0 1 3.52 2.1 6.4 6.4 0 0 1 1 3.85A6.59 6.59 0 0 1 23.4 27a11.5 11.5 0 0 1-7.19 2h-10Zm7 9.9h2.1a3.74 3.74 0 0 0 2.32-.62 2.13 2.13 0 0 0 .82-1.83c0-1.45-1.09-2.17-3.28-2.17h-2Zm0 5.1v5.42h2.45c2.18 0 3.27-.91 3.27-2.75a2.36 2.36 0 0 0-.88-2 4 4 0 0 0-2.53-.69Z" />
  </svg>
);
const ForwardRef = forwardRef(IconTextBoldFilledSVG);
ForwardRef.displayName = "IconTextBoldFilled";
export { ForwardRef as IconTextBoldFilled };
